import React, { useState } from "react";
import "./CustomTooltipTop.scss";

export function CustomTooltipTop({
  trigger,
  boldText,
  normalText,
  minWidth = "340px",
  maxWidth = "450px",
  minHeight = "66px",
  maxHeight,
}) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="custom-tooltip-top-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <div className="custom-tooltip-top-trigger">{trigger}</div>
      {isVisible && (
        <div
          className="custom-tooltip-top-popup"
          style={{ minWidth, maxWidth, minHeight }}
        >
          <div className="custom-tooltip-top-content">
            <div className="custom-tooltip-top-bold">{boldText}</div>
            <div className="custom-tooltip-top-normal">{normalText}</div>
          </div>
          <div className="custom-tooltip-top-arrow"></div>
        </div>
      )}
    </div>
  );
}
